import React from 'react';
import { FaTimes, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { useNotification } from '../../context/NotificationContext';
import styles from './GlobalNotification.module.css';

const GlobalNotification = () => {
  const { notifications, removeNotification } = useNotification();

  if (notifications.length === 0) return null;

  return (
    <div className={styles.notificationContainer}>
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`${styles.notification} ${notification.success ? styles.success : styles.error}`}
        >
          <div className={styles.icon}>
            {notification.success ? (
              <FaCheckCircle size={20} />
            ) : (
              <FaExclamationCircle size={20} />
            )}
          </div>
          <div className={styles.content}>
            <h4 className={styles.title}>
              {notification.title}
            </h4>
            <p 
              className={styles.message}
              dangerouslySetInnerHTML={{ __html: notification.message }}
            />
          </div>
          <button
            onClick={() => removeNotification(notification.id)}
            className={styles.closeButton}
          >
            <FaTimes size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default GlobalNotification;
